<template>
  <div class="mitgliederverwaltung-fristennueberwachung">
    <NavigationBar
      showBackBtn
      titel="Details"
      :actions="actions"
    ></NavigationBar>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="start">
            <v-col cols="12" sm="12" md="6">
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
              ></v-skeleton-loader>
              <deadline-detail-card
                v-else
                :deadline="deadline"
              ></deadline-detail-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
              ></v-skeleton-loader>

              <deadline-detail-counter-card
                v-else
                :deadline="deadline"
                hideTitle
                :deadlineEntries="deadlineEntries"
                showDeadlineDistribution
              ></deadline-detail-counter-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card-heading, table"
              ></v-skeleton-loader>
              <v-card v-else>
                <personnel-record-deadlines-data-table
                  title="Fristeneinträge für diesen Wert"
                  :deadlines="deadlineEntries"
                  showNames
                  showHistory
                  showDocuments
                  allowGrouping
                  allowGroupingByPerson
                  allowGroupingByStatus
                  allowExport
                ></personnel-record-deadlines-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
    <router-view />
  </div>
</template>

<script>
import { db } from "@/firebase";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import DeadlineDetailCard from "@/components/member-management/deadlines/DeadlineDetailCard.vue";
import DeadlineDetailCounterCard from "@/components/member-management/deadlines/DeadlineDetailCounterCard.vue";
import PersonnelRecordDeadlinesDataTable from "@/components/member-management/personnel-records/PersonnelRecordDeadlinesDataTable.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import {
  MEMBER_MANAGEMENT_DEADLINES_update,
  MEMBER_MANAGEMENT_DEADLINES_delete,
} from "@/data/permission-types.js";

export default {
  name: "member-management-deadline-monitoring-deadline-details",
  components: {
    NavigationBar,
    DeadlineDetailCard,
    DeadlineDetailCounterCard,
    PersonnelRecordDeadlinesDataTable,
    SupportTools,
  },
  data() {
    return {
      actions: [
        {
          title: "Bearbeiten",
          permissions: `${MEMBER_MANAGEMENT_DEADLINES_update}`,
          icon: "mdi-pencil",
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "member-management-deadline-monitoring-deadline-edit",
              params: { id: this.deadline.meta.id },
            });
          },
        },
        {
          title: "Sammeleingabe",
          permissions: `${MEMBER_MANAGEMENT_DEADLINES_update}`,
          icon: "mdi-form-textbox",
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "member-management-deadline-monitoring-deadline-bulk-input",
              params: { id: this.deadline.meta.id },
            });
          },
        },
        {
          title: "Löschen",
          permissions: `${MEMBER_MANAGEMENT_DEADLINES_delete}`,
          icon: "mdi-delete",
          actionStyle: "textBtn",
          // function: this.deleteItem,
          disabled: true,
        },
        { divider: true },
        { actionStyle: "clipboardBtn" },
      ],
      deadline: null,
      deadlineEntries: [],
      dataIsLoading: true,
      deadlineUnsubscribe: null, // store unsubscribe function
      deadlineEntriesUnsubscribe: null, // store unsubscribe function for entries
    };
  },
  computed: {
    deadlines() {
      return [];
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [
        { title: "deadline", data: this.deadline },
        { title: "deadlineEntries", data: this.deadlineEntries },
      ];
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    $route: {
      handler: "initialize",
      immediate: false,
    },
  },
  beforeDestroy() {
    if (this.deadlineUnsubscribe) {
      this.deadlineUnsubscribe();
      this.deadlineUnsubscribe = null;
    }
    if (this.deadlineEntriesUnsubscribe) {
      this.deadlineEntriesUnsubscribe();
      this.deadlineEntriesUnsubscribe = null;
    }
  },
  methods: {
    async initialize() {
      this.dataIsLoading = true;
      // Unsubscribe previous listeners if exist
      if (this.deadlineUnsubscribe) {
        this.deadlineUnsubscribe();
        this.deadlineUnsubscribe = null;
      }
      if (this.deadlineEntriesUnsubscribe) {
        this.deadlineEntriesUnsubscribe();
        this.deadlineEntriesUnsubscribe = null;
      }
      try {
        await Promise.all([this.getDeadline(), this.getDeadlineEntries()]);
      } catch (error) {
        this.$emit("error", error);
        // Optionally, show a snackbar or alert here
      }
      this.dataIsLoading = false;
    },
    getDeadline() {
      // Set up Firestore live listener
      // Always clear previous listener before setting a new one
      if (this.deadlineUnsubscribe) {
        this.deadlineUnsubscribe();
        this.deadlineUnsubscribe = null;
      }
      return new Promise((resolve) => {
        const ref = db
          .collection("organizations")
          .doc(this.$route.params.organizationId)
          .collection("deadlines")
          .doc(this.$route.params.itemId);
        // Set unsubscribe immediately
        this.deadlineUnsubscribe = ref.onSnapshot(
          (doc) => {
            if (doc.exists) {
              this.deadline = doc.data();
              console.log("change");
            } else {
              this.deadline = null;
              console.warn("No such document found!");
            }
            resolve();
          },
          (error) => {
            console.error("Error fetching document:", error);
            resolve();
          }
        );
      });
    },
    getDeadlineEntries() {
      // Always clear previous listener before setting a new one
      if (this.deadlineEntriesUnsubscribe) {
        this.deadlineEntriesUnsubscribe();
        this.deadlineEntriesUnsubscribe = null;
      }
      // Set up Firestore live listener for deadlineEntries
      return new Promise((resolve) => {
        const ref = db
          .collection("organizations")
          .doc(this.$route.params.organizationId)
          .collection("deadlineEntries")
          .where("deadline.id", "==", this.$route.params.itemId);
        let firstSnapshot = true;
        this.deadlineEntriesUnsubscribe = ref.onSnapshot(
          (querySnapshot) => {
            const deadlineEntries = [];
            querySnapshot.forEach((doc) => {
              deadlineEntries.push({ id: doc.id, ...doc.data() });
              console.log("change", doc.id, doc.data());
            });
            // Use Vue.set to ensure reactivity if needed
            this.deadlineEntries = deadlineEntries;
            if (firstSnapshot) {
              resolve();
              firstSnapshot = false;
            }
          },
          (error) => {
            console.error("Error querying documents:", error);
            resolve();
          }
        );
      });
    },
    deleteItem() {},
  },
};
</script>
